import type { ReactNode } from 'react';
import { cn } from '../lib/cn';
import { LogoMark } from './brand';

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-line px-6 py-16 text-center',
        className,
      )}
    >
      <div className="text-primary/70 [&_svg]:size-10">{icon ?? <LogoMark />}</div>
      <h3 className="font-display text-2xl text-fg">{title}</h3>
      {description ? (
        <p className="max-w-md text-sm leading-relaxed text-muted">{description}</p>
      ) : null}
      {action}
    </div>
  );
}
